import React from 'react'
import SectionTitle2 from '../sectionTitle/SectionTitle2';
import { Element } from 'react-scroll';
import { Link } from 'react-router-dom';

const HomeIndustriesWeServe = () => {
  const industries = [
    {
      title: "Agriculture",
      link: "agriculture",
    },
    {
      title: "Energy",
      link: "energy",
    },
    {
      title: "Manufacturing",
      link: "manufacturing",
    },
    {
      title: "Healthcare",
      link: "healthcare",
    },
    {
      title: "Maritime",
      link: "maritime",
    },
    {
      title: "Public Sector",
      link: "public-sector",
    },
  ]
  return (
    <>
    <Element
        name="HomeEdgeAIProductSuite"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5 justify-content-center">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Industries We Serve"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Tailored AI solutions for diverse sectors driving innovation and efficiency.</p>
            </div>
            {industries.map((industry) => <div className="col-12 col-lg-2 px-0 px-md-4 mt-4 mt-md-5" key={industry.title}>
              <div className="home-iws-card">
                <Link to={`/solutions/${industry.link}`}>{industry.title}</Link>
              </div>
            </div>)}
          </div>
        </div>
      </Element>
    </>
  )
}

export default HomeIndustriesWeServe;